// A short tap of the phone when something is done (a task completed). Nothing in a browser.
import { Haptics, NotificationType } from '@capacitor/haptics';
import { isNative } from './platform';

export function done() {
  if (isNative()) Haptics.notification({ type: NotificationType.Success }).catch(() => {});
}
